import { render, staticRenderFns } from "./SettingsConnectBraintree.vue?vue&type=template&id=3665cdac&"
import script from "./SettingsConnectBraintree.vue?vue&type=script&lang=js&"
export * from "./SettingsConnectBraintree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports